var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCelsiaLogoShort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.14 23.895c0-10.159 8.241-17.402 19.263-17.402 6.156 0 11.22 2.07 14.596 5.926l-5.263 4.61c-2.383-2.634-5.361-3.951-8.936-3.951-6.653 0-11.32 4.42-11.32 10.723 0 6.302 4.667 10.723 11.32 10.723 3.575 0 6.553-1.317 8.936-3.95L51 35.181c-3.376 3.857-8.44 6.02-14.596 6.02-11.022.094-19.263-7.148-19.263-17.307z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.33,
    height: 16.33,
    rx: 8.165,
    fill: "#2424FF"
  })));
}

export default SvgCelsiaLogoShort;